import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Modal,
  CircularProgress,
  Paper,
  TextField,
  Typography,
  Avatar,
  Badge,
  Checkbox,
  ListItemText,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { height, Stack, width } from "@mui/system";
import React, { useEffect, useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../comman/SnackBarUI";


import InputLabel from "@mui/material/InputLabel";
// import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import { createVideoAction } from "../../redux/toolkit/video/createVideo";
import { getAllVideoAction } from "../../redux/toolkit/video/allVideo";
import { getSingleVideoAction } from "../../redux/toolkit/video/getSingleVideo";
import { vi } from "date-fns/locale";
import { editVideoAction } from "../../redux/toolkit/video/editVideo";

const partnerSchema = yup
  .object({
    // name: yup.string().required("Partner Name is required"),
  })
  .required();

const EditVideo = ({ state, setState, videoId }) => {
  const [snack, setSnack] = useState(false);
  const [partner, setPartner] = useState("");
  const [triggerValue, setTriggerValue] = useState(0);


  console.log("snack=========================================================>", snack , "state ========", state);

  const dispatch = useDispatch();
  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);

  const {
    register,
    setValue,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(partnerSchema) });
  const skipStatusWatch = watch("skipStatus");


  const handleClose = () => {
    setState(false);
  };

  let triggerArr = [
    "profiler Start",
    "profiler Complete",
    "survey complete",
    "survey disqualification",
    "Partner Open",
  ];

  const videoData = useSelector((state) => state.singelVideo);
  const { status, message, loading, data } = videoData;

  const editVideoData = useSelector((state) => state.editVideo);
  const { status: editVideoStatus, message: editVideoMessage, loading: editVideoLoading, data: editVideoInfo } = editVideoData;

  console.log("editVideoInfo =========================>", editVideoInfo);

  const handdleEditVideo = async (data) => {
    setSnack(true);

    const createVideo = await dispatch(
      editVideoAction({
        ...data,
        triggerpoints: triggerValue,
        partnerId: partner,
        video_id: videoId,
      })
    );


    setState(false);
    if (createVideo?.payload?.status === 200) {
      await dispatch(getAllVideoAction());
    }
    
  };

  const handlePartnerChange = (event) => {
    setPartner(event.target.value);
  };

  const handleChange = (event) => {
    console.log("event ===================>", event?.target.value);
    setTriggerValue(event.target.value);
  };

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  useEffect(() => {
    dispatch(getSingleVideoAction({ video_id: videoId }));
  }, []);

  useEffect(() => {
    if (data) {
      setPartner(data?.partnerId);
      setTriggerValue(data?.triggerpoints);
    }

    reset({
      videoLink: data?.videoLink,
      timeGap: data?.timeGap,
      isActive: data?.isActive,
    //   skipStatus: data?.skipStatus?.isSkip,
    //   skipStatus: data?.skipStatus?.timeGap,
    skipStatus: {
      isSkip: data?.skipStatus?.isSkip,
      timeGap: data?.skipStatus?.timeGap,
    },
      dailyLimit: data?.dailyLimit,
      // isGlobal: data?.isGlobal,
      dailyTriggerHits: data?.dailyTriggerHits
    });
  }, [data, reset]);

  return (
    <>
      <Modal sx={{ overflow: "scroll" }} open={state} onClose={handleClose}>
        <Box className="modal_box">
          <Card sx={{ width: 500, p: 5 }}>
            <Typography variant="h5" sx={{ mb: 5 }} align="center">
              Edit Video
            </Typography>

            <form
              sx={{ height: "auto" }}
              onSubmit={handleSubmit(handdleEditVideo)}
            >
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ minWidth: 120 }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label"></InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={triggerValue}
                        label="Age"
                        onChange={handleChange}
                      >
                        {triggerArr.map((item, index) => (
                          <MenuItem value={index+1}>
                            {" "}
                            {triggerArr[index]}{" "}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box sx={{ minWidth: 120, marginBottom: "20px" }}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Select Partner
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled = {triggerValue === 5 ? false : true}
                        value={partner}
                        label="Select Partner"
                        onChange={handlePartnerChange}
                      >
                        {partnerDetails?.data?.map((item) => {
                          return (
                            <MenuItem value={item._id}>{item.name}</MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="videoLink"
                    variant="outlined"
                    placeholder="videoLinkame"
                    {...register("videoLink")}
                    error={!!errors?.videoLink?.message}
                    helperText={errors?.videoLink?.message}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="timeGap"
                    variant="outlined"
                    placeholder="timeGap"
                    {...register("timeGap")}
                    error={!!errors?.videoLink?.message}
                    helperText={errors?.videoLink?.message}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                      //   <Switch
                      //     {...register("isActive")}
                      //     color="primary"
                      //     defaultChecked={false}
                      //   />
                      <Switch
                        {...register("isActive")}
                        checked={watch("isActive") || false} // read live value
                        color="primary"
                      />
                    }
                    label="Is Active"
                  />
                  {errors?.isActive && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.isActive.message}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                    //   <Switch
                    //     {...register("skipStatus.isSkip")}
                    //     color="primary"
                    //     defaultChecked={false} 
                    //   />
                    <Switch
                        {...register("skipStatus.isSkip")}
                        checked={watch("skipStatus.isSkip") || false} // read live value
                        color="primary"
                      />
                    }
                    label="Skip?"
                  />
                  {errors?.skipStatus?.isSkip && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.skipStatus.isSkip.message}
                    </p>
                  )}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="SkipStatus Time Gap"
                    variant="outlined"
                    disabled={!skipStatusWatch?.isSkip}
                    type="number"
                    placeholder="Enter time gap"
                    {...register("skipStatus.timeGap", { valueAsNumber: true })}
                    error={!!errors?.skipStatus?.timeGap}
                    helperText={errors?.skipStatus?.timeGap?.message}
                  />
                </Grid>

                {/* // timeGap (Number) */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="dailyLimit"
                    variant="outlined"
                    type="number"
                    placeholder="Enter dailyLimit"
                    {...register("dailyLimit", { valueAsNumber: true })}
                    error={!!errors?.dailyLimit}
                    helperText={errors?.dailyLimit?.message}
                  />
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                  <FormControlLabel
                    control={
                   
                    <Switch
                        {...register("isGlobal")}
                        checked={watch("isGlobal") || false} // read live value
                        color="primary"
                      />
                    }
                    label="isGlobal?"
                  />
                  {errors?.isGlobal && (
                    <p style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors.skipStatus.isSkip.message}
                    </p>
                  )}
                </Grid> */}

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="dailyTriggerHits"
                    variant="outlined"
                    type="number"
                    placeholder="Enter dailyTriggerHits"
                    disabled = {(triggerValue === 3 || triggerValue === 4) ? false : true}
                    {...register("dailyTriggerHits", { valueAsNumber: true })}
                    error={!!errors?.dailyTriggerHits}
                    helperText={errors?.dailyTriggerHits?.message}
                  />
                </Grid>


              </Grid>

              <Stack direction="row" spacing={2} mt={3}>
                <Button
                  sx={{ zIndex: 1000 }}
                  variant="contained"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? <CircularProgress /> : "Edit Video"}
                </Button>

                <Button variant="contained" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Stack>
            </form>
          </Card>
        </Box>
      </Modal>

    { <SnackBarUI
        state={snack}
        setState={setSnack}
        status={editVideoStatus}
        message={editVideoMessage}
      />}
    </>
  );
};

export default EditVideo;
